import React, { useContext, memo } from "react";

import MenuIcon from "@material-ui/icons/Menu";
import AppBar from "@material-ui/core/AppBar";
import Grid from "@material-ui/core/Grid";
import Toolbar from "@material-ui/core/Toolbar";

import { useHistory } from "react-router-dom";
import { SidebarContext } from "../../context/SidebarContext";
import "./header.css";

const Header = () => {
  const history = useHistory();
  const { handleChangeOpenSidebar, openSidebar } = useContext(SidebarContext);

  const handleChangeSide = () => {
    handleChangeOpenSidebar(!openSidebar);
  };

  return (
    <>
      <div className="root-header">
        <AppBar position="fixed" className="header">
          <Toolbar>
            <MenuIcon
              style={{ color: "white", cursor: "pointer", fontSize: 30 }}
              onClick={handleChangeSide}
            />

            <Grid
              container
              item
              spacing={0}
              alignItems="center"
              justify="center"
              style={{ marginLeft: 10 }}
              xs={12}
            >
              <Grid item xs={12} container alignItems="center">
                <img
                  className="img-header"
                  src="img/QyonPlug.svg"
                  alt="App Logo"
                  onClick={() => history.push("/homePage")}
                />
              </Grid>
              <Grid item xs={12} container alignItems="center">
                <label className="version">Versão - 1.29.1</label>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
      </div>
    </>
  );
};

export default memo(Header);
